import React from "react";
import ReactApexChart from "react-apexcharts";

const NonSaudiFacultyByProgramChart = ({
  malePercentages = [],
  femalePercentages = [],
  categories = [],
  title = "نسبة هيئة التدريس غير السعوديين (ذكور وإناث) حسب البرنامج",
  colors = ["#f39c12", "#c0392b"],
  height = 350,
}) => {
  const series = [
    {
      name: "ذكور",
      data: malePercentages,
    },
    {
      name: "إناث",
      data: femalePercentages,
    },
  ];

  const options = {
    chart: {
      height,
      toolbar: { show: false },
      type: "area",
    },
    colors,
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      fontFamily: "Cairo",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 7,
      curve: "smooth",
    },
    fill: {
      opacity: 0.25,
      type: "solid",
    },
    xaxis: {
      categories,
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
      title: {
        text: "البرامج",
        style: {
          fontFamily: "Cairo",
          fontSize: "14px",
        },
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      labels: {
        formatter: (val) => `${val}%`,
        style: {
          fontFamily: "Cairo",
        },
      },
      title: {
        // text: "النسبة المئوية",
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(2)}%`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3" style={{ fontFamily: "Cairo" }}>{title}</h5>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={height}
      />
    </div>
  );
};

export default NonSaudiFacultyByProgramChart;
